import { buildGetRequest } from '@/_helper/apiHelper';
import { errorReport } from '@/_helper/errorReport';

const getDocument = async (bookingId: string, service: string, documentType?: string) => {
    const requestConfig = buildGetRequest(window.$serviceUrl, '/documentservice', {
        bookingId: bookingId,
        requestSource: 'customerarea',
        requestType: 'documentservice',
        service: service ?? '',
        documentType: documentType ?? '',
    });
    return fetch(requestConfig.url, {
        method: requestConfig.method,
        headers: requestConfig.headers,
    })
        .then(async (response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            return await response.json();
        })
        .catch((e) => {
            errorReport({ source: 'DocumentService', error: e });
            return Promise.reject();
        });
};

const DocumentService = {
    getDocument,
};
export default DocumentService;
